export default "__VITE_PUBLIC_ASSET__ce6317f9__"